import { FIND_REPORT_REQUEST, findReportSuccess, findReportFailure} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findReportEpic(action$, store$, { ReportRepository }) {
    return action$.pipe(
        ofType(FIND_REPORT_REQUEST),
        mergeMap( action =>{
            const { id } = action.payload;

            if(!id.trim()) {
                return EMPTY;
            }

            return from(
                ReportRepository.findById( id )
                    .then( findReportSuccess )
                    .catch( findReportFailure ),
            );
        }),
    );
}
